import {
    Divider,
    Link,
    Spacer
} from "@nextui-org/react";
import {
    HelmetWrapper
} from "../inc/js/Helper"

export default function PrivacyPolicy() {
    return (
        <>
            <HelmetWrapper
                title="JudgeAutos - Privacy Policy"
                description="Read JudgeAutos' privacy policy detailing how we handle user data for car show registration, judging, and event management."
                url="PrivacyPolicy"
            />
        
            <div className="flex-col mx-auto sm:w-2/3">
                <h1 className="text-5xl text-center">Privacy Policy</h1>
                <Spacer y={5} />
                <div className="text-left sm:text-lg mb-10">
                    <p className="text-center">Last updated: 6/10/2024</p>
                    <Spacer y={5} />

                    <p>JudgeAutos.com ("us", "we", or "our") operates the https://judgeautos.com website (the "Service").</p>
                    <Spacer y={2} />
                    <p>This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.</p>
                    <Spacer y={2} />
                    <p>We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Information Collection And Use</h2>
                    <Spacer y={5} />
                    <p>We collect several different types of information for various purposes to provide and improve our Service to you.</p>
                    <Spacer y={10} />

                    <h3 className="text-center text-2xl">Types of Data Collected</h3>
                    <Spacer y={5} />
                    <h4 className="text-xl underline">Personal Data</h4>
                    <Spacer y={2} />
                    <p>While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:</p>
                    <Spacer y={5} />
                    <ul className="list-disc list-inside">
                        <li>Email address</li>
                        <li>First name and last name</li>
                        <li>Phone number</li>
                        <li>Address, State, Province, ZIP/Postal code, City</li>
                    </ul>
                    <Spacer y={5} />

                    <h4 className="text-xl underline">Usage Data</h4>
                    <Spacer y={5} />
                    <p>We may also collect information on how the Service is accessed and used ("Usage Data").</p>
                    <Spacer y={2} />
                    <p>This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                    <Spacer y={5} />

                    <h4 className="text-xl underline">Tracking & Cookies Data</h4>
                    <Spacer y={5} />
                    <p>We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.</p>
                    <Spacer y={2} />
                    <p>Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.</p>
                    <Spacer y={2} />
                    <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.</p>
                    <Spacer y={5} />

                    <h5 className="text-lg underline">Examples of Cookies we use:</h5>
                    <Spacer y={5} />
                    <ul className="list-disc list-inside">
                        <li>Session Cookies: We use Session Cookies to operate our Service.</li>
                        <li>Preference Cookies: We use Preference Cookies to remember your preferences and various settings.</li>
                        <li>Security Cookies: We use Security Cookies for security purposes.</li>
                        <li>Use of Data</li>
                    </ul>
                    <Spacer y={5} />

                    <h5 className="text-lg underline">JudgeAutos.com uses the collected data for various purposes:</h5>
                    <Spacer y={5} />
                    <ul className="list-disc list-inside">
                        <li>To provide and maintain the Service</li>
                        <li>To notify you about changes to our Service</li>
                        <li>To allow you to participate in interactive features of our Service</li>
                        <li>To provide customer care and support</li>
                        <li>To provide analysis or valuable information so that we can improve the Service</li>
                        <li>To monitor the usage of the Service</li>
                        <li>To detect, prevent, and address technical issues</li>
                    </ul>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Transfer Of Data</h2>
                    <Spacer y={5} />
                    <p>Your information, including Personal Data, may be transferred to and maintained on computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ from those of your jurisdiction.</p>
                    <Spacer y={2} />
                    <p>If you are located outside the United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to the United States and process it there.</p>
                    <Spacer y={2} />
                    <p>Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.</p>
                    <Spacer y={2} />
                    <p>JudgeAutos.com will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Disclosure Of Data</h2>
                    <Spacer y={5} />
                    <p>JudgeAutos.com may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
                    <Spacer y={2} />
                    <ul className="list-disc list-inside">
                        <li>To comply with a legal obligation</li>
                        <li>To protect and defend the rights or property of JudgeAutos.com</li>
                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>To protect the personal safety of users of the Service or the public</li>
                        <li>To protect against legal liability</li>
                    </ul>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Security Of Data</h2>
                    <Spacer y={5} />
                    <p>The security of your data is important to us but remember that no method of transmission over the Internet or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Service Providers</h2>
                    <Spacer y={5} />
                    <p>We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services, or to assist us in analyzing how our Service is used.</p>
                    <Spacer y={2} />
                    <p>These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Links To Other Sites</h2>
                    <Spacer y={5} />
                    <p>Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
                    <Spacer y={2} />
                    <p>We have no control over and assume no responsibility for the content, privacy policies, or practices of any third party sites or services.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Children's Privacy</h2>
                    <Spacer y={5} />
                    <p>Our Service does not address anyone under the age of 18 ("Children").</p>
                    <Spacer y={2} />
                    <p>We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Changes To This Privacy Policy</h2>
                    <Spacer y={5} />
                    <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>
                    <Spacer y={2} />
                    <p>We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.</p>
                    <Spacer y={2} />
                    <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
                    <Spacer y={10} />
                    <Divider className="my-10" />

                    <h2 className="text-center text-3xl">Contact Us</h2>
                    <div className="text-center">
                        <Spacer y={5} />
                        <p>If you have any questions about this Privacy Policy, please contact us:</p>
                        <Spacer y={2} />
                        <p>By email: <Link href="mailto:privacy@judgeautos.com">privacy@judgeautos.com</Link></p>
                        <p>By visiting this page on our website: <Link href='https://judgeautos.com/ContactUs'>https://judgeautos.com/ContactUs</Link></p>
                    </div>
                </div>
            </div>
        </>
    );
}